import { React, useState } from 'react';
import Select from 'react-select';

const OtherDetails = ({ }) => {
    const [precision, setPrecision] = useState();
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(500px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Water Meter Reading</label>
                        <input type="text" className="p-2 form-control w-75" name="periodto" />
                    </div>
                    <div className="d-flex gap-3">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Forwading Address</label>
                        <input className='center mt-1'
                            type="checkbox"
                            style={{ width: "20px", height: "20px" }}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Reading Date</label>
                        <input type="date" className="p-2 form-control w-75" name="periodto" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Refund Letter Sent <br/>to Landlord</label>
                        <textarea type="text" className="p-2 form-control w-75" name="periodto" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Elec Meter Reading</label>
                        <input type="text" className="p-2 form-control w-75" name="periodto" />
                    </div>
                    <div></div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Reading Date</label>
                        <input type="date" className="p-2 form-control w-75" name="periodto" />
                    </div>
                    <div></div>
                    <div>
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Inspection Comments</label>
                        <textarea type="text" className="form-control" name="periodto" />
                    </div>
                    <div>
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks / Comments</label>
                        <textarea type="text" className="p-2 form-control " name="periodto" />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default OtherDetails;